<script lang="ts" setup>
import { storeToRefs } from "pinia";
import { computed } from "vue";

import type { TModelInfo } from "@/lib/types/GlobeTypes.js";
import { useGlobeControlStore } from "@/store/store";

const model = defineModel<string>({ required: true });

const props = defineProps<{
  modelInfo: TModelInfo;
}>();

const store = useGlobeControlStore();
const { loading, varinfo } = storeToRefs(store);

const variableOptions = computed(() => {
  const visibleVars = Object.keys(props.modelInfo.vars).filter((varname) => {
    const varinfo = props.modelInfo.vars[varname];
    return !varinfo.hidden;
  });
  return visibleVars;
});

const currentVarUnits = computed(() => {
  return varinfo.value?.attrs?.units ?? "-";
});

const currentVarLongname = computed(() => {
  return varinfo.value?.attrs?.long_name;
});

const currentVarStandardName = computed(() => {
  return varinfo.value?.attrs?.standard_name;
});
</script>

<template>
  <div class="column">
    <div class="control">
      <div class="select is-fullwidth mb-2" :class="{ 'is-loading': loading }">
        <select v-model="model" class="form-control">
          <option
            v-for="varname in variableOptions"
            :key="varname"
            :value="varname"
          >
            {{ varname }}
            <span
              v-if="
                modelInfo.vars[varname]?.attrs?.long_name ||
                modelInfo.vars[varname]?.attrs?.standard_name
              "
            >
              -
              {{
                modelInfo.vars[varname].attrs.long_name ??
                modelInfo.vars[varname].attrs.standard_name
              }}
            </span>
          </option>
        </select>
      </div>
      <div class="has-text-right">
        <span v-word-break>
          {{ currentVarLongname || currentVarStandardName || "-" }}
        </span>
        / {{ currentVarUnits }}
      </div>
    </div>
  </div>
</template>
